import React        from 'react';
import PropTypes    from 'prop-types';
import Translations from '../../utils/Translations';

class CtaButton extends React.Component {
	render() {
		return (
			<span className="magazine-home--cta">
				<div className="btn">{Translations.get('MagazineFeaturedReadOn')}</div>
			</span>
		);
	}
}

CtaButton.propTypes = {
	url: PropTypes.string.isRequired,
};

export default CtaButton;
